import { loading, success, reset, handleErrorException } from 'State/actions';

import * as types from './types';

export const getNutritionStandards = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(
        loading(types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_LOADING, true)
      );

      const response = await MPWWebApi.getGeneric(
        'CycleMenu/GetNutritionStandards'
      );

      dispatch(
        success(
          types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_SUCCESS,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_ERROR,
          { Title: 'Error', Message: 'Unable to get nutrition standards' }
        )
      );
    } finally {
      dispatch(
        loading(types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_LOADING, false)
      );
    }
  };
};

export const clearGetNutritionStandardsResult = () => {
  return (dispatch) => {
    dispatch(reset(types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_SUCCESS, []));
    dispatch(reset(types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_ERROR, null));
  };
};

export const getCycleMenus = (params) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.FOODBASEDANALYSIS_GETCYCLEMENUS_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        'CycleMenu/GetCycleMenus',
        { Filter: params }
      );

      dispatch(
        success(
          types.FOODBASEDANALYSIS_GETCYCLEMENUS_SUCCESS,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.FOODBASEDANALYSIS_GETCYCLEMENUS_ERROR, {
          Title: 'Error',
          Message: 'Unable to get cycle menus',
        })
      );
    } finally {
      dispatch(loading(types.FOODBASEDANALYSIS_GETCYCLEMENUS_LOADING, false));
    }
  };
};

export const clearGetCycleMenusResult = () => {
  return (dispatch) => {
    dispatch(reset(types.FOODBASEDANALYSIS_GETCYCLEMENUS_SUCCESS, []));
    dispatch(reset(types.FOODBASEDANALYSIS_GETCYCLEMENUS_ERROR, null));
  };
};



// WEBPACK FOOTER //
// ./src/pages/reports/menus/foodbasedanalysisreport/state/actions.js